import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Renderer from "components/Renderer";
import Error from "components/Error";
import { selectSecurityStatus, selectSecurityError } from "reducers";
import { fetchFormById, idGenerated } from "reducers/formSlice";
import { fetchAttachmentsByFormId } from "reducers/attachmentsSlice";
import { fetchWorkflowsByFormId } from "reducers/workflowsSlice";
import { useParams } from "react-router-dom";
import { fetchTreeByDomain } from "reducers/treesSlice";
import { fetchWorkflowHistoryByFormId } from "reducers/workflowHistorySlice";
import { fetchRcs } from "./assetRc/assetRcSlice";
import { fetchDivisions } from "./division/divisionSlice";
import GlobalLoading from "components/GlobalLoading";
import IeCheck from "components/IeCheck";
import { dispatchCapexForm } from "./form-definition/capex";

const CapexQna = () => {
	const [ready, setReady] = useState(false);
	const { formDefinitionId, formId } = useParams();
	const securityStatus = useSelector(selectSecurityStatus);
	const securityError = useSelector(selectSecurityError);
	const { status, message } = securityError || {};
	const dispatch = useDispatch();
	const TREE_DOMAIN = "Test";

	useEffect(() => {
		const fetchFormDefinition = async () => {
			dispatch(fetchTreeByDomain({ domain: TREE_DOMAIN }));
			dispatch(
				fetchRcs({ code: "WTMHADS", stateKey: "mentalHealthRcs" })
			);
			dispatch(fetchRcs({ code: "WTFACIL", stateKey: "facilityRcs" }));
			dispatch(fetchRcs({ code: "WTTOTAL", stateKey: "rcs" }));
			dispatch(fetchDivisions());
		};

		const fetchCommon = async () => {
			dispatch(fetchWorkflowsByFormId({ responseFormId: formId }));
			dispatch(fetchWorkflowHistoryByFormId({ responseFormId: formId }));
		};

		const fetchForm = async () => {
			dispatch(fetchFormById(formId));
			dispatch(fetchAttachmentsByFormId(formId));
		};

		const fetchAll = async () => {
			//reset store every time a new form or form def is loaded
			dispatch({ type: "RESET" });
			//this dispatches form def based on the javascript capex.js file
			dispatchCapexForm();
			//always fetch definition
			fetchFormDefinition();
			//fetch form if id was passed
			if (formId) {
				fetchCommon();
				await fetchForm();
			} else {
				//generate a new ID for the new form
				dispatch(idGenerated());
			}
			setReady(true);
		};
		fetchAll();
	}, [dispatch, formId, formDefinitionId]);

	return securityStatus === "failed" ? (
		<Error error={status} message={message} />
	) : ready ? (
		<IeCheck>
			<Renderer />
		</IeCheck>
	) : (
		<GlobalLoading />
	);
};

export default CapexQna;
